import { render, staticRenderFns } from "./ReceiveReservationForm.vue?vue&type=template&id=a3b2d04c"
import script from "./ReceiveReservationForm.vue?vue&type=script&lang=js"
export * from "./ReceiveReservationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports